import { useTranslation } from 'translations/hooks';

import Button from 'ui/button';

export type ShowMoreToggleProps = {
  enableToggle: boolean;
  toggleState: boolean;
  toggleFunc: () => void;
};

export const ShowMoreToggle = ({
  enableToggle,
  toggleState,
  toggleFunc,
}: ShowMoreToggleProps) => {
  const { t } = useTranslation();

  if (!enableToggle) {
    return null;
  }

  return (
    <Button type="link" onClick={() => toggleFunc()} size="large">
      {toggleState ? t('common.show_less') : t('common.show_more')}
    </Button>
  );
};
